import React from 'react'
import { Button, buttonClasses, styled } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripHorizontal } from '@fortawesome/pro-solid-svg-icons/faGripHorizontal'
import { SHOW_QUESTIONS_BTN_ATTRIBUTES, TEST_ELEMENT_IDS } from '@app/constants'

type Props = {
  modalButtonRef: React.MutableRefObject<HTMLButtonElement>
  onShowQuestionsModal: () => void
  isQuestionsModalOpen: boolean
}

export const TestTakingNavigator: React.FC<Props> = ({
  modalButtonRef,
  onShowQuestionsModal,
  isQuestionsModalOpen,
}) => {
  return (
    <StyledButton
      ref={modalButtonRef}
      onClick={onShowQuestionsModal}
      startIcon={<FontAwesomeIcon icon={faGripHorizontal} />}
      variant='outlined'
      color='grey'
      size='small'
      {...SHOW_QUESTIONS_BTN_ATTRIBUTES}
      aria-haspopup='dialog'
      aria-expanded={isQuestionsModalOpen}
      aria-controls={TEST_ELEMENT_IDS.allQuestionsModal}
      role='button'
      aria-label='Question Navigation'
    >
      Question Navigation
    </StyledButton>
  )
}

const StyledButton = styled(Button)(({ theme }) => ({
  [`& .${buttonClasses.startIcon} > *:nth-of-type(1)`]: {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(16),
  },
}))
